const Typography = ({
  size = "lg",
  weight = "bold",
  color = "black",
  position = "center",
  className = "",
  children,
  ...props
}) => (
  <div
    className={`
      title-${size} 
      weight-${weight} 
      title-${color} 
      title-${position} 
      ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default Typography;
